export default "__VITE_ASSET__BPu7Y950__"